// extracted by mini-css-extract-plugin
export default {"cartTableRow":"cartRowEmpty_cartTableRow__TUB33"};